import ResourcesModule from '../../resources/resources';

export class EditBidPriceModalController {
  /* @ngInject */
  constructor(dimensionName, dimensionValue, maxBidPricesCampaignBestMatch, close) {
    this.maxBidPricesCampaignBestMatch = maxBidPricesCampaignBestMatch;
    this.dimensionName = dimensionName;
    this.dimensionValue = dimensionValue;
    this.previousBidPrice = this.bidPrice = maxBidPricesCampaignBestMatch.max_bid_price;
    this.blacklisted = this.bidPrice === 0;
    this.close = close;
  }

  handleBidPriceChange(value) {
    this.previousBidPrice = value;
    if(value) {
      this.blacklisted = false;
    } else {
      this.blacklisted = true;
    }
  }

  handleBlacklistedToggle(blacklisted) {
    // NOTE this.blacklisted here is the old value, right before it gets changed. Don't know why.
    if(!blacklisted) {
      this.previousBidPrice = this.bidPrice;
      this.bidPrice = 0;
    } else {
      this.bidPrice = this.previousBidPrice;
    }
  }

  save() {
    this.maxBidPricesCampaignBestMatch.max_bid_price = this.bidPrice;
    if(this.maxBidPricesCampaignBestMatch.max_bid_price == 0) {
      this.maxBidPricesCampaignBestMatch.fallback = 0;
    }
    this.close(this.maxBidPricesCampaignBestMatch);
  }
}

export default angular.module('app.components.campaigns.explore.bidPriceEditModal', [
  ResourcesModule.name
])
  .controller('EditBidPriceModalController', EditBidPriceModalController);



/** WEBPACK FOOTER **
 ** ./src/components/campaigns/editBidPriceModal.js
 **/